/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Forced_Update_TitleInputs */

const en_mobile_forced_update_title = /** @type {(inputs: Mobile_Forced_Update_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update required`)
};

const es_mobile_forced_update_title = /** @type {(inputs: Mobile_Forced_Update_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización necesaria`)
};

/**
* | output |
* | --- |
* | "Update required" |
*
* @param {Mobile_Forced_Update_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_forced_update_title = /** @type {((inputs?: Mobile_Forced_Update_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Forced_Update_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_forced_update_title(inputs)
	return en_mobile_forced_update_title(inputs)
});